import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { bindAction } from '../../../common/utils/actions';
import { toggleSelection } from '../../actions';
import SelectCell from './select-cell';

function mapDispatchToProps(
  dispatch: Dispatch,
  props: { tableName: string }
): { toggleSelection: ReturnType<typeof toggleSelection> } {
  return {
    toggleSelection: bindAction(toggleSelection, { multiSelectName: props.tableName }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(SelectCell);
